import { ArrowUpRight } from "lucide-react";
import { FadeIn } from "../components/FadeIn";
import { capabilities } from "../content/portfolio";
import { useMediaQuery } from "../hooks/useMediaQuery";

function CapabilityDetails({
  name,
  description,
  tools,
}: {
  name: string;
  description: string;
  tools: readonly string[];
}) {
  const isPhone = useMediaQuery("(max-width: 767px)");

  return (
    <details className="capability-details" open={!isPhone}>
      <summary>查看说明与工具</summary>
      <p>{description}</p>
      <ul aria-label={`${name}相关工具`}>
        {tools.map((tool) => <li key={tool}>{tool}</li>)}
      </ul>
    </details>
  );
}

export function CapabilitiesSection() {
  return (
    <section id="capabilities" aria-labelledby="capabilities-heading" className="capabilities-section">
      <FadeIn as="h2" id="capabilities-heading" y={34} className="section-heading section-heading--light">
        能力系统
      </FadeIn>
      <div className="capabilities-intro">
        <p>不是工具清单，而是从执行到发布结论的完整能力组合。</p>
        <a href="#projects" className="capabilities-jump">
          在项目中查看应用
          <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>

      <div className="capability-list">
        {capabilities.map((capability, index) => (
          <FadeIn
            as="article"
            key={capability.number}
            delay={index * 0.06}
            className="capability-row"
          >
            <span className="capability-number" aria-hidden="true">{capability.number}</span>
            <div className="capability-copy">
              <h3>{capability.name}</h3>
              <CapabilityDetails
                name={capability.name}
                description={capability.description}
                tools={capability.tools}
              />
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}

export { CapabilitiesSection as ServicesSection };
